// Session-reset registry (contract 06 §7) — replaces v3's `resetAllStores` hardcoded 11-store
// import list. Feature stores subscribe their own `reset`; AuthLogoutFlow runs them all on
// logout / 401 / handoff swap, keeping auth free of cross-feature store imports.
const resets = new Set<() => void>()

/** Subscribe a store's reset. Returns an unsubscribe fn. */
export function registerSessionReset(fn: () => void): () => void {
  resets.add(fn)
  return () => {
    resets.delete(fn)
  }
}

/** Run every registered reset; one failing store must not block the others. */
export function runSessionResets(): void {
  for (const reset of resets) {
    try {
      reset()
    } catch {
      /* isolate a failing store's reset */
    }
  }
}
